import LoginForm from 'components/organisms/form/LoginForm'
import LoginFormHeader from 'components/organisms/form/LoginFormHeader'
import React from 'react'

const LoginTemplate = () => {
    return (
        <>
            <LoginFormHeader />
            <LoginForm />
        </>
    )
}

export default LoginTemplate
